
import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink, Download } from 'lucide-react';
import { TrackDownload } from '@/lib/types';

interface DownloadActionsProps {
  isLiked: boolean;
  countdownActive: boolean;
  timeLeft: number;
  downloadReady: boolean;
  isDownloading: boolean;
  onLikeTrack: () => void;
  onDownload: () => void;
}

const DownloadActions: React.FC<DownloadActionsProps> = ({
  isLiked,
  countdownActive,
  timeLeft,
  downloadReady,
  isDownloading,
  onLikeTrack,
  onDownload
}) => {
  return (
    <div className="space-y-4">
      {!isLiked ? (
        <Button 
          onClick={onLikeTrack} 
          className="w-full"
          size="lg"
        >
          <ExternalLink size={16} className="mr-2" />
          Like on Spotify to Unlock Reward
        </Button>
      ) : (
        <>
          {countdownActive ? (
            <div className="text-center py-2">
              <p className="text-sm text-muted-foreground animate-pulse-subtle">Verifying your like...</p>
            </div>
          ) : (
            <Button 
              onClick={onDownload} 
              disabled={!downloadReady || isDownloading} 
              variant={downloadReady ? "default" : "outline"}
              size="lg"
              className="w-full"
              // Removed the download attribute as it's not a valid prop for the Button component
            >
              {isDownloading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Downloading...
                </>
              ) : (
                <>
                  <Download size={16} className="mr-2" />
                  {downloadReady ? "Download Now" : "Processing..."}
                </>
              )}
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export default DownloadActions;
